import styled from 'styled-components';
import { Price } from '../../fuse-price/src/index';
import { gridConfig as breakpoints } from '../../fuse-responsive-grid/src/grid';
import { Save } from '../../fuse-save/src/save';
import { TypographyComponent } from '../../fuse-typography-element/src/typography';

const CardContainer = styled.div.attrs({
	className: 'fuse-complex-product-card',
})`
	width: 100%;
	min-width: 100%;
	position: relative;
`;

const StyledProductcard = styled.a.attrs({
	className: 'fuse-complex-product-card__link',
	'data-testid': 'fuse-complex-product-card__link',
})`
	display: inline-flex;
	position: relative;
	flex-direction: column;
	width: 100%;
	min-width: 0;

	text-decoration: none;

	&:focus-visible {
		outline: var(--border-width-s) solid var(--color-functional-focus);
	}

	&:focus:not(:focus-visible) {
		outline: none;
	}
`;

const BrandContainer = styled(TypographyComponent).attrs({
	className: 'fuse-complex-product-card__brand',
	'data-testid': 'fuse-complex-product-card__brand',
})`
	margin-bottom: var(--spacing-global-space2);
	min-height: calc(var(--font-size-1) + 4px);
	display: block;
	max-width: 100%;
	text-overflow: ellipsis;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
`;

const TitleContainer = styled(TypographyComponent).attrs({
	className: 'fuse-complex-product-card__title',
	'data-testid': 'fuse-complex-product-card__title',
})`
	display: block;
	margin: 0 0 var(--spacing-global-space3);
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
`;

const StyledPrice = styled(Price).attrs({
	className: 'fuse-complex-product-card__price',
	'data-testid': 'fuse-complex-product-card__price',
})`
	margin: 0 0 var(--spacing-global-space3);
`;

const StyledSaveForLater = styled(Save).attrs({
	className: 'fuse-complex-product-card__save-for-later',
	'data-testid': 'fuse-complex-product-card__save-for-later',
	'data-cnstrc-btn': 'add_to_wishlist',
})`
	position: absolute;
	padding: var(--spacing-global-space2);
	top: 5px;
	right: 5px;

	@media only screen and (min-width: ${breakpoints.m.minWidth}) {
		top: 9px;
		right: 9px;
	}

	@media only screen and (min-width: ${breakpoints.l.minWidth}) {
		top: 13px;
		right: 13px;
	}
`;

const TaggstarWrapper = styled.div.attrs({
	className: 'productInfo',
})``;

const TaggstarContainer = styled.div.attrs({
	className: 'persuasive-message',
})``;

const SpaceUnderImage = styled.div`
	height: var(--spacing-global-space5);
`;

export {
	CardContainer,
	StyledProductcard,
	BrandContainer,
	TitleContainer,
	StyledSaveForLater,
	StyledPrice,
	TaggstarWrapper,
	TaggstarContainer,
	SpaceUnderImage,
};
